import { render, staticRenderFns } from "./UserField.vue?vue&type=template&id=523cca46"
import script from "./UserField.vue?vue&type=script&lang=js"
export * from "./UserField.vue?vue&type=script&lang=js"
import style0 from "./UserField.vue?vue&type=style&index=0&id=523cca46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports